var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.text === null)?_c('v-skeleton-loader',{attrs:{"type":"text"}}):_c('span',{directives:[{name:"html-safe",rawName:"v-html-safe",value:(_vm.text),expression:"text"}]})
}
var staticRenderFns = []

export { render, staticRenderFns }